import { FileJson, HelpCircle, Quote, Link2, Table, BarChart3 } from "lucide-react";

export const GeoVsSeoStrategies = () => {
  const strategies = [
    {
      icon: HelpCircle,
      title: "Add FAQ Schema to Every Page",
      description: "LLMs love Q&A format. Add FAQ schema with common questions and definitive answers. Structure your content so AI can easily extract and cite it.",
      example: "Question: 'What is DMARC?' Answer: 'DMARC is an email authentication protocol that...'",
    },
    {
      icon: Quote,
      title: "Write Citable Definitions",
      description: "Start sections with clear, quotable definitions. AI models look for authoritative statements they can attribute to your source.",
      example: "'Email deliverability is the ability to successfully land emails in recipients' inboxes rather than spam folders.'",
    },
    {
      icon: FileJson,
      title: "Use Dataset and HowTo Schemas",
      description: "Beyond FAQ, implement Dataset schema for statistics and HowTo for processes. These structured formats are easier for AI to parse and cite.",
      example: "Dataset: '84% of emails reach the inbox globally' with source attribution",
    },
    {
      icon: Table,
      title: "Include Benchmark Tables",
      description: "LLMs frequently cite specific statistics. Tables with clear data, sources, and years are prime citation targets. Make your data easy to extract.",
      example: "Industry benchmark tables with columns for Metric, Value, Source, Year",
    },
    {
      icon: Link2,
      title: "Cross-Link Related Content",
      description: "Create topic clusters that demonstrate expertise. Internal linking signals topical authority to both search engines and AI training processes.",
      example: "DMARC guide → SPF guide → DKIM guide → Email Security hub",
    },
    {
      icon: BarChart3,
      title: "Track AI Citations",
      description: "Monitor when AI tools cite your content. Use Perplexity's cite sources feature to see if your content appears. Track mentions in ChatGPT responses.",
      example: "Search your brand + topic in Perplexity to check citation frequency",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        GEO Optimization Strategies
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        These tactics help your content get discovered and cited by AI models like ChatGPT, 
        Perplexity, and Claude.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {strategies.map((strategy, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/10 to-purple-500/10 flex items-center justify-center mb-4">
              <strategy.icon className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">{strategy.title}</h3>
            <p className="text-sm text-muted-foreground mb-4">{strategy.description}</p>
            <div className="text-xs text-muted-foreground bg-muted/50 p-3 rounded-lg font-mono">
              {strategy.example}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};